export default "/images/9e56bdebb06590be7750a57d79311735.avif";